var exports = {
  "w7": "repositoryInfoContainer__KXKv-x",
  "tB": "repositoryInfoContainerLarge__4ehFBC",
  "eI": "repositoryIcon__JMwtxB",
  "ov": "ownerLink__RE557z",
  "w2": "repositoryNameLink__6mR01i",
  "tL": "smallRepositoryPill__iDUA0m",
  "v7": "repositoryLabel__tvCgz-",
};

module.exports = exports;
